import { Route, Routes } from 'react-router-dom'
import EvaluationPage from './Page'

export default function EvaluationListIndex() {
  return (
    <Routes>
        <Route path="/" element={<EvaluationPage />} />
        <Route path="/:id" element={<EvaluationPage />} />
        <Route path=":resource/:id" element={<EvaluationPage />} />
    </Routes>
  )
}